import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

import { Column, DataTable, DataTableContainer, TableActionButton } from 'components/DataTable';
import { useApi } from '../../../hooks/useApi';
import { useConfirmedAction } from 'hooks/useConfirmedAction';
import { useModal } from 'hooks/useModal';
import { useCallback, useRef } from 'react';
import { SpaceBlockingGroupForm } from '.';
import { SpaceBlockingGroup } from '../types';
import { Button } from '@ui';

interface Props {
    clubSlug: string;
}

export const SpaceBlockingGroupList = ({ clubSlug }: Props) => {
    const [setModal, resetModal] = useModal();
    const confirm = useConfirmedAction({
        message: (
            <>
                <p>Möchtest du diese Blockierungsgruppe wirklich löschen?</p>
                <div className="alert alert-warning">
                    <strong>Achtung!</strong> Wenn du eine Blockierungsgruppe löscht, werden alle Blockierungen dieser
                    Gruppe der Standard Blockierungsgruppe zugewiesen!
                </div>
            </>
        )
    });
    const api = useApi();
    const asyncList = useRef<any>(undefined);

    const handleShowSpaceBlockingGroupForm = useCallback(
        (group?: SpaceBlockingGroup) =>
            setModal({
                title: group ? `Gruppe "${group.name}" bearbeiten` : 'Gruppe erstellen',
                content: (
                    <SpaceBlockingGroupForm
                        group={group}
                        clubSlug={clubSlug}
                        callback={() => {
                            asyncList.current?.reload();
                            resetModal();
                        }}
                    />
                ),
                show: true
            }),
        []
    );

    const handleDeleteSpaceBlockingGroup = useCallback((group: SpaceBlockingGroup) => {
        api({
            url: `space/blocking/group/${group.id}`,
            method: 'DELETE',
            onSuccess: () => asyncList.current?.reload()
        }).catch(() => {});
    }, []);

    const columns: Column[] = [
        {
            uid: 'name',
            name: 'Name'
        },
        {
            uid: 'color',
            name: 'Farbe',
            renderer(value) {
                return <div style={{ height: '25px', width: '25px', backgroundColor: value }} />;
            }
        },
        {
            uid: 'actions',
            name: 'Optionen',
            align: 'end'
        }
    ];

    return (
        <DataTableContainer>
            <Button className="tw-py-5" onPress={() => handleShowSpaceBlockingGroupForm()}>
                Gruppe erstellen
            </Button>
            <DataTable
                asyncListRef={asyncList}
                columns={columns}
                tableProps={{
                    sticked: true,
                    bordered: true,
                    borderWeight: 'light',
                    compact: false
                }}
                hideSearchBar
                fetchUrl={`space/blocking/group/${clubSlug}`}
                rowActions={(item) => (
                    <TableActionButton.Container justify="end">
                        <TableActionButton icon={faEdit} onPress={() => handleShowSpaceBlockingGroupForm(item)} />
                        <TableActionButton
                            icon={faTrash}
                            onPress={() => confirm(() => handleDeleteSpaceBlockingGroup(item))}
                        />
                    </TableActionButton.Container>
                )}
            />
        </DataTableContainer>
    );
};

export default SpaceBlockingGroupList;
